document.addEventListener('DOMContentLoaded', function () {
  const coverBar = document.querySelector('.sticky-bar.cover-hidden');
  const hero = document.querySelector('.banner-second-level.pattern.maroon');
  const heroOption2 = document.querySelector('.banner-second-level.option-2');
  const header = document.querySelector('header.site-header');

  if (!coverBar || !header) {
    return;
  }

  function updateHeaderHeight() {
    const headerHeight = header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    return headerHeight;
  }

  // Keep the cover bar flush against wherever the header actually is on
  // screen right now, so it tracks the header as it hides/shows (and
  // animates) on scroll (see _navigation.js), instead of assuming the
  // header is always fully visible at its resting height.
  function updateCoverBarTop() {
    const top = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    coverBar.style.top = `${top}px`;
    return top;
  }

  // Continuously re-sync the top position on every frame while the bar is
  // active, since the header's position can change from scrolling, its own
  // CSS transition, or a resize.
  let rafId = null;
  function trackHeaderTop() {
    updateCoverBarTop();
    rafId = window.requestAnimationFrame(trackHeaderTop);
  }
  function startTracking() {
    if (rafId === null) {
      trackHeaderTop();
    }
  }
  function stopTracking() {
    if (rafId !== null) {
      window.cancelAnimationFrame(rafId);
      rafId = null;
    }
  }

  // Set initial header height
  updateHeaderHeight();

  // Option 2 page
  if (heroOption2) {
    coverBar.classList.remove('cover-hidden');
    coverBar.classList.add('sticky-mode');
    startTracking();
    return;
  }

  // Maroon hero page
  if (!hero || !('IntersectionObserver' in window)) {
    return;
  }

  const io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        stopTracking();
        coverBar.classList.remove('show');
        coverBar.style.top = '';
      } else {
        startTracking();
        coverBar.classList.add('show');
      }
    });
  });

  io.observe(hero);
});
